// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC } from "react";

export interface CopyRightStyles {
    copyRightMessage?: TypographyPresentationProps;
}

export const copyRightStyles: CopyRightStyles = {};

const styles = copyRightStyles;

type Props = WidgetProps;

const CopyRight: FC<Props> = () => {
    return (
        <Typography {...styles.copyRightMessage}>
            {siteMessage("Custom_CopyRight", String(new Date().getFullYear()))}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: CopyRight,
    definition: {
        group: "Common",
        displayName: "Copy Right",
    },
};

export default widgetModule;
